import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
  selector: "field-set-date-format",
  templateUrl: "./field-set-date-format.component.html",
  styles: [],
})
export class FieldSetDateFormatComponent {

  @Input() public fieldOptions: any;
  @Output() public dataChanged = new EventEmitter();

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }

}
